<template>
<div>
  <iframe id="designerFrame"
    style="position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;"
    src="/abpm-modeller/index.html">
      <input type="hidden" id="processId" :value="processId">
      <input type="hidden" id="processName" :value="processName"> 
      <input type="hidden" id="applicationId" :value="applicationId">
      <input type="hidden" id="isXMLAvailable" :value="modelXML === 'null' ? '' : 'xmlData'">
      <input type="hidden" id="applicationProcId" :value="processName">
      <input type="hidden" id="servletContextPath" :value="SERVLET_CONTEXT_PATH" />
      <input type="hidden" id="modellerVersion" :value="modellerVersion" />
      <a id="helpLink" :href="baseHelpUrl" target="_abpmPageHelp" style="padding: 4px; display: none"></a>
  </iframe>
</div>
</template>

<script>
import axios from "axios";
import constants from "../constants";

export default {
  data() {
    return {
      interval: null,
      baseUrl: constants.BASE_URL,
      applicationId: this.$route.params.applicationId,
      processId: this.$route.params.processId,
      processName: localStorage.getItem('processName'),
      modelXML:  localStorage.getItem('modelXML'),
      SERVLET_CONTEXT_PATH: constants.BASE_URL,
      modellerVersion: process.env.VUE_APP_MODELLER_VERSION,
      baseHelpUrl: localStorage.getItem('helpUrlLink') + 'Modeller_(Process_Design_and_Edit)%2Fbpm_modeller.htm'
    };
  },
  created() {
    const refreshToken = () => {
      axios.get(process.env.VUE_APP_CONTEXT_PATH + "/tokenrefresh", { withCredentials: true })
        .then(() => console.log('Token has been refreshed'))
        .catch((error) => console.error('Cannot aquire token due to an error', error))
    }
		localStorage.setItem('isIntegratedVersion', true);
    if (constants.TOKEN_REFRESH_INTERVAL) {
      refreshToken();
      this.interval = setInterval(refreshToken, constants.TOKEN_REFRESH_INTERVAL * 60 * 1000);
    }
    let csrf = this.getCookie('XSRF-TOKEN');
    $('head').append(`<meta name="_csrf" content="${csrf}" />`);
    $('head').append(`<meta name="_csrf_header" content="X-XSRF-TOKEN" />`);
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    getCookie(name) {
      if (!document.cookie) {
          return null;
      }
      const xsrfCookies = document.cookie.split(';')
          .map(c => c.trim())
          .filter(c => c.startsWith(name + '='));

      if (xsrfCookies.length === 0) {
          return null;
      }
      return decodeURIComponent(xsrfCookies[0].split('=')[1]);
    }
  }

};
</script>